import SecondaryHotelsLayer from '../layers/SecondaryHotelsLayer';
import SecondaryHotelsProvider from '../layers/providers/SecondaryHotelsProvider';
import ListHotelsProvider from '../components/autocomplete/providers/ListHotelsProvider';
import ListCategoriesProvider from '../components/autocomplete/providers/ListCategoriesProvider';
import GooglePlacesAutocomplete from 'components/autocomplete/providers/GoogleAutocomplete';
import Autocomplete from '../components/autocomplete/Autocomplete';
import DirectionsMobileCTA from '../components/directionsMobileCTA/DirectionsMobileCTA';
import HotelLocation from '../components/hotelLocation/HotelLocation';
import hotelSummaryMobilePanel from '../components/hotelSummaryMobilePanel/hotelSummaryMobilePanel';
import MessageControl from 'components/messageControl/MessageControl';
import MeliaMainMenu from '../components/meliaMainMenu/MeliaMainMenu';
import MeliaWidget from './MeliaWidget';

export default MeliaWidget.extend({
	validation: require('./hotelDetailsWidget.schema.json'),

	constructor(containerId, config, api) {
		MeliaWidget.prototype.constructor.call(this, containerId, config, api);
	},

	initialize() {
		MeliaWidget.prototype.initialize.call(this);
	},

	onInitialized() {
		MeliaWidget.prototype.onInitialized.call(this);
		this.initializeBaseLayer();
		this.addComponent(
			new MeliaMainMenu({
				identifier: 'main-menu',
				widget: this,
				componentClass: 'melia-main-menu-class',
				classPrefix: '.melia-main-menu-class-',
				position: 'TOP_LEFT',
				visible: true,
				properties: {
					components: {
						MainBox: {
							position: 'main-box-container',
							componentConstructorClass: 'MainBox',
							properties: {
								maxResults: 10
							}
						},
						DirectionsBox: {
							position: 'directions-box-container',
							componentConstructorClass: 'DirectionsBox',
							componentClass: 'directions-box',
							properties: {
								blockHotelInput: true
							}
						},
						JPRouteDetails: {
							position: 'route-details-container',
							componentConstructorClass: 'JPRouteDetails',
							componentClass: 'jp-route-details',
							properties: {}
						}
					}
				}
			})
		);
		this.addComponent(
			new MessageControl({
				identifier: `message-control${this.isMobileVersion ? '-mobile' : ''}`,
				position: 'TOP_RIGHT',
				widget: this
			})
		);

		this.addComponent(
			new HotelLocation({
				identifier: 'main-menu',
				widget: this,
				componentClass: 'melia-main-menu-class',
				classPrefix: '.melia-main-menu-class-',
				position: 'RIGHT_BOTTOM',
				visible: true,
				properties: {}
			})
		);

		if (this.isMobileVersion) {
			this.addMobileComponents();
		}

		this.getMainHotelData(this.hotelsJson.mainHotel.id).then(hotelData => {
			this.bus.trigger('UPDATED_HOTEL_SELECTED_DATA', hotelData);
			if (this.isMobileVersion) {
				this.addComponent(
					new hotelSummaryMobilePanel({
						identifier: 'hotel-summary-panel',
						widget: this,
						componentClass: 'hotel-summary-panel',
						classPrefix: 'hotel-summary-panel',
						position: 'BOTTOM_CENTER',
						visible: true,
						properties: {
							hotelData
						}
					})
				);
			}
		});
	},

	addMobileComponents() {
		this.addComponent(
			new DirectionsMobileCTA({
				identifier: 'directions-mobile-cta',
				widget: this,
				componentClass: 'directions-mobile-cta',
				classPrefix: 'directions-mobile-cta',
				position: 'RIGHT_BOTTOM',
				visible: true
			})
		);
	},

	registerConfigClasses(
		registerComponent,
		registerLayer,
		registerLayerProvider
	) {
		if (this.hotelsJson.alternativeHotelList) {
			registerLayer('SecondaryHotelsLayer', SecondaryHotelsLayer);
			registerLayerProvider('SecondaryHotelsProvider', SecondaryHotelsProvider);
		}
		Autocomplete.registerProviderClass(
			'GPlacesAutocomplete',
			GooglePlacesAutocomplete
		);
		Autocomplete.registerProviderClass(
			'ListCategoriesProvider',
			ListCategoriesProvider
		);
		Autocomplete.registerProviderClass(
			'ListHotelsProvider',
			ListHotelsProvider
		);
		registerComponent('MessageControl', MessageControl);
		registerComponent('MeliaMainMenu', MeliaMainMenu);
		registerComponent('DirectionsMobileCTA', DirectionsMobileCTA);
		registerComponent('HotelLocation', HotelLocation);
		registerComponent('hotelSummaryMobilePanel', hotelSummaryMobilePanel);
	},

	initializeBaseLayer() {
		this.initBaseMapLayer();
		if (this.hotelsJson.alternativeHotelList) {
			this.addLayer(
				new SecondaryHotelsLayer({
					widget: this,
					provider: SecondaryHotelsProvider,
					id: 'SecondaryHotelsLayer',
					iconMarker: {
						default: {
							url: this.hotelsJson.alternativeHotelList.iconMarker
						},
						hover: {
							url: this.hotelsJson.alternativeHotelList.iconMarker
						},
						selected: {
							url: this.hotelsJson.alternativeHotelList.iconMarker
						}
					},
					featureId: 'id',
					minZoom: this.config.minZoom
				})
			);
		}
		if (this.hotelsJson && this.hotelsJson.mainHotel) {
			let icon = this.createIcon(this.hotelsJson);
			this.addMarkerToLayer('BaseMapLayer', this.hotelsJson.mainHotel, icon);
			let location = new google.maps.LatLng(
				this.hotelsJson.mainHotel.position.lat,
				this.hotelsJson.mainHotel.position.lng
			);
			this.map.setCenter(location);
		}
	}
});



// WEBPACK FOOTER //
// ./src/widget/HotelDetailsWidget.js